/** admin/launch — API. */
import { http } from '../../_shared/http';
import type { TestPersona, LaunchMatchPayload, LaunchMatchResult } from './types';

export const adminLaunchApi = {
  fetchTestPersonas: () => http.get<TestPersona[]>('/admin/test-personas'),
  launchMatch: (payload: LaunchMatchPayload) => http.post<LaunchMatchResult>('/admin/launch-match', payload),
};
